import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import ArrowLeft from '@images/svg-icons/arrowLeft.svg';

import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import { getLabelFallback } from '@utils/utils';

import * as actions from '@redux-actions/';

interface Props {
    labelMenu?: string;
    backLabel?: string;
    isOnlineOrders?: boolean;
    onBackButtonClick?: () => void;
}

const MobileHeader = ({
    labelMenu,
    backLabel,
    isOnlineOrders = false,
    onBackButtonClick,
}: Props): JSX.Element => {
    const [onlineOrdersTotalOrdersLabel, setOnlineOrdersTotalOrdersLabel] = useState<string>(null);

    const onlineOrdersHistory = useSelector((state: RootState) => state.myPurchases.onlineOrders);
    const config = useSelector((state: RootState) => state.common.config);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        onlineOrdersHistory?.length > 1
            ? setOnlineOrdersTotalOrdersLabel(
                  getLabelFallback('MYPURCHASES_ONLINE_ORDERS_TOTAL_ORDERS')?.replace(
                      '{TOTAL_ORDERS}',
                      onlineOrdersHistory.length
                  )
              )
            : onlineOrdersHistory?.length === 1
            ? setOnlineOrdersTotalOrdersLabel(
                  getLabelFallback('MYPURCHASES_ONLINE_ORDERS_TOTAL_ORDERS_SINGLE_ORDER')
              )
            : null;
    }, [onlineOrdersHistory]);
    return (
        <div className="mobile-menu">
            <button
                role="region"
                aria-label="back button"
                className="back-button"
                onClick={
                    onBackButtonClick
                        ? onBackButtonClick
                        : () => {
                            navigate(config.pagesUrl.dashboard);
                            dispatch(actions.setIsMenuMobileSelected(false));
                        } 
                }
            >
                <span className="start-icon">
                    <ArrowLeft />
                </span>
                <span>{backLabel}</span>
            </button>
            {labelMenu && isOnlineOrders ? (
                <div role="region" aria-label="mobile menu title" className="mobile-menu-header">
                    <h2 role="heading" aria-label="mobile menu title" className="mobile-menu-title">
                        {labelMenu}
                    </h2>
                </div>
            ) : (
                <h2 role="heading" aria-label="mobile menu title" className="mobile-menu-title">
                    {labelMenu}
                </h2>
            )}
        </div>
    );
};
export default MobileHeader;
